import { Route } from "react-router-dom"
import TournamentPrintouts from "../../components/tournament/tournament-printouts/tournament-printouts"

export const getTournamentPrintoutRoutes = () => {
  return (
    <Route path="documents" element={<TournamentPrintouts/>}></Route>
  )
}